<template>
    <button type="submit" class="y-btn y-btn_main y-fields__btn-main" @click="$emit('click')">
        <span class="y-btn__txt">{{ label }}</span>
    </button>
</template>

<script>
import {mapGetters} from "vuex";

export default {
    name: "Button",
    props: {
        label: { type: String , required: true},
    },
}
</script>
